/** Quadratic cost: sum of v² for nonnegative integers v. */
export function quadraticCost(allocations: Record<string, number>): number {
	let s = 0;
	for (const v of Object.values(allocations)) {
		if (!Number.isInteger(v) || v < 0) throw new RangeError("allocations must be nonnegative integers");
		s += v * v;
	}
	return s;
}

const BUDGET = 100;

export function quadraticBudgetRemaining(allocations: Record<string, number>): number {
	return BUDGET - quadraticCost(allocations);
}

export function quadraticWithinBudget(allocations: Record<string, number>): boolean {
	return quadraticCost(allocations) <= BUDGET;
}
